export default "__VITE_ASSET__CbaPw9ku__"